<template>
  <v-container
    v-if="!loadingSubCat"
    grid-list-sm
    :class="['mx-auto', 'mb-12', 'mt-n1']"
    style="max-width: 1140px"
  >
    <v-data-iterator
      :items="visiblePages"
      :no-data-text="''"
      :items-per-page="itemPage"
      :page.sync="page"
      hide-default-footer
    >
      <template v-slot:default="props">
        <v-card class="menu" flat>
          <v-row no-gutters>
            <v-col class="text-left" cols="12" v-if="dataUser.IndAutenticado">
              <v-chip color="transparent" label text-color="black" small>
                <Paleta
                  class="mr-1"
                  :height="30"
                  :width="30"
                  :viewbox="`0 -1 30 30`"
                />
                Paleta
              </v-chip>
              <v-chip
                class="ma-1"
                color="transparent"
                label
                small
                text-color="black"
              >
                <Paquete
                  :height="35"
                  :width="25"
                  :viewbox="`0 -3 35 25`"
                  class="mr-1"
                />
                Paquete
              </v-chip>
             
            </v-col>
            <v-col
              class="text-left "
              :cols="6"
              v-if="dataUser.IndAutenticado"
            >
              <ExportPdf />
            </v-col>
            <v-col
              class="text-right"
              :cols="6"
             v-if="$vuetify.breakpoint.smAndDown"
            >
            <filtroDisponible />
            </v-col>
            <v-spacer v-if="!dataUser.IndAutenticado"></v-spacer>
            <v-col
              class="text-right"
              :cols="$vuetify.breakpoint.name === 'xs' ? 12 : 6"
            >
              <span class="grey--text">N° de Items</span>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    dark
                    text
                    color="black"
                    class="ml-2 elevation-0"
                    v-bind="attrs"
                    v-on="on"
                    small
                  >
                    {{ itemPage }}
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(number, index) in listaItem"
                    :key="index"
                    @click="updateItemsPerPage(number)"
                  >
                    <v-list-item-title>{{ number }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <span class="mr-4 grey--text" v-if="numPage > 1">
                Pag {{ page }} de {{ numPage }}
              </span>
              <v-icon
                color="primary"
                x-large
                class="mr-4"
                @click="formerPage"
                v-if="numPage > 1"
              >
                mdi-chevron-left-circle
              </v-icon>

              <v-icon
                color="primary"
                x-large
                v-if="numPage > 1"
                @click="nextPage"
              >
                mdi-chevron-right-circle
              </v-icon>
            </v-col>
          </v-row>
        </v-card>

        <v-row dense class="mt-4">
          <v-col
            v-for="item in props.items"
            :key="item.Codigo"
            md="4"
            sm="6"
            lg="3"
            xl="3"
            cols="12"
          >
            <cardP :item="item" :verbtn="false" />
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
    <v-snackbar
      v-model="setMsg"
      :timeout="timeout"
      absolute
      bottom
      :color="CarMsj.Type"
      right
    >
      {{ CarMsj.Msj }}
    </v-snackbar>
  </v-container>
</template>

<script>
  import { mapState, mapMutations, mapGetters } from "vuex";
  import filtroDisponible from "../components/FiltroDisponible";
  import cardP from "../components/ItemGrid/CardProducto";
  import { InfoExistencia } from "./InfoExistencia";
  import { Paleta, Paquete } from "./Icons";
  import { ExportPdf } from "./PdfArticulos";
  export default {
    name: "gridapp",
    data() {
      return {
        reveal: false,
        selected: 20,
        promoDetalleArt: [],
        cantMin: 1,
        codXart: false,
        codArtPromo: null,
        menu: false,
        fab: false,
        timeout: 2000,
      };
    },
    methods: {
      ...mapMutations([
        "set_page",
        "minus_page",
        "clr_page",
        "set_mensaje",
      ]),
      nextPage() {
        if (this.page + 1 <= this.numPage) {
          this.set_page();
          this.goTo();
        }
      },
      formerPage() {
        if (this.page - 1 >= 1) {
          this.minus_page();
          this.goTo();
        }
      },
      updateItemsPerPage(number) {
        this.clr_page();
        this.selected = number;
      },
      goTo() {
        window.scrollTo(0, 0);
      },
    },
    computed: {
      ...mapState([
        "page",
        "loadingSubCat",
        "dataUser",
        "CarOverlay",
        "CarMsj",
      ]),
      ...mapGetters([
        "filterconsolidado",
      ]),
      setMsg: {
        get() {
          return this.CarOverlay;
        },
        set(value) {
          this.set_mensaje({ Visible: value, Msj: "", Type: "" });
        },
      },
      listaItem() {
        let itemspag = [],
          valuesArray = [12, 20, 48];
        if (this.filterconsolidado.length >= this.selected) {
          valuesArray.forEach((item) => {
            if (this.filterconsolidado.length >= item) itemspag.push(item);
            else itemspag.push(this.filterconsolidado.length);
          });
        }

        return itemspag;
      },
      itemPage() {
        return this.selected;
      },
      numPage() {
        return Math.ceil(this.filterconsolidado.length / this.itemPage);
      },
      visiblePages() {
        return this.filterconsolidado.slice(
          (this.page - 1) * this.itemPage,
          this.page * this.itemPage
        );
      },
    },
    components: {
      cardP,
      InfoExistencia,
      Paquete,
      Paleta,
      ExportPdf,
      filtroDisponible
    },
  };
</script>

<style scoped>
  .border {
    border: 2px dashed orange;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    transform: translateX(2em);
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.3s ease;
  }
  .box {
    width: 200px;
    height: 300px;
    position: relative;
    border: 1px solid #bbb;
    background: #eee;
  }
  .ribbon2 {
    position: absolute;
    right: -15px;
    top: -5px;
    z-index: 1;
    overflow: hidden;
    width: 75px;
    height: 75px;
    text-align: right;
  }
  .ribbon2 span {
    font-size: 10px;
    font-weight: bold;
    color: #fff;
    text-transform: uppercase;
    text-align: center;
    line-height: 20px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    width: 100px;
    display: block;
    background: #79a70a;
    background: linear-gradient(#ffa000 0%, #fbc02d 100%);
    box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
    position: absolute;
    top: 19px;
    right: -21px;
  }
  .ribbon2 span::before {
    content: "";
    position: absolute;
    left: 0px;
    top: 100%;
    z-index: -1;
    border-left: 3px solid #fbc02d;
    border-right: 3px solid transparent;
    border-bottom: 3px solid transparent;
    border-top: 3px solid #fbc02d;
  }
  .scale-enter-active,
  .scale-leave-active {
    transition: all 0.5s ease;
  }
  .scale-enter-from,
  .scale-leave-to {
    opacity: 0;
    transform: scale(0.9);
  }
  .menu {
    position: sticky;
    top: 92px;
    z-index: 3;
    margin-bottom: 5px;
  }
  @media (max-width: 600px) {
    .menu {
      top: 140px;
    }
  }
</style>
